// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursur-pointer[data-v-414f8b12]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
